// @flow
import React from 'react';

import { Introduction } from 'Components/frameworks/introduction/Introduction.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

type Props = {
  config: CMSContent,
  countryInfos: {
    description: string,
    title: string,
  },
  id?: string,
};

export function CountryIntroductionLine({
  countryInfos: { description = '', title = '' },
  config: {
    common: { viewMore, loadLess },
  },
  id,
}: Props) {
  return (
    <SiteContainer id={id} className="Line">
      <Introduction
        text={description}
        title={title}
        seeMoreLabel={viewMore}
        seeLessLabel={loadLess}
      />
    </SiteContainer>
  );
}
